var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"agGrid-page container"},[_c('base-header',[_c('refresh-analytics',{attrs:{"type":"commissions"}})],1),_c('base-ag-grid',{attrs:{"columnDefs":_vm.columnDefs,"datasource":_vm.datasource}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }